import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGke = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 42,
	viewBox: "0 0 43 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3868 34.9358L4.2448 22.5644C3.97023 22.0888 3.82568 21.5493 3.82568 21.0001C3.82568 20.451 3.97023 19.9114 4.2448 19.4358L11.3868 7.06445C11.6614 6.58879 12.0564 6.1938 12.532 5.91918C13.0077 5.64456 13.5472 5.49999 14.0965 5.5H28.3806C29.4983 5.5 30.5311 6.09639 31.0902 7.06445L38.2322 19.4358C38.5068 19.9114 38.6514 20.451 38.6514 21.0001C38.6514 21.5493 38.5068 22.0888 38.2322 22.5644L31.0902 34.9358C30.8156 35.4115 30.4206 35.8064 29.945 36.081C29.4693 36.3556 28.9298 36.5001 28.3806 36.5H14.0965C13.5473 36.5 13.0079 36.3554 12.5323 36.0808C12.0567 35.8063 11.6615 35.4114 11.3868 34.9358Z",
			fill: "url(#paint0_linear_112721_616)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_112721_616",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 3,
			y: 5,
			width: 36,
			height: 32,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.3868 34.9358L4.2448 22.5644C3.97023 22.0888 3.82568 21.5493 3.82568 21.0001C3.82568 20.451 3.97023 19.9114 4.2448 19.4358L11.3868 7.06445C11.6614 6.58879 12.0564 6.1938 12.532 5.91918C13.0077 5.64456 13.5472 5.49999 14.0965 5.5H28.3806C29.4983 5.5 30.5311 6.09639 31.0902 7.06445L38.2322 19.4358C38.5068 19.9114 38.6514 20.451 38.6514 21.0001C38.6514 21.5493 38.5068 22.0888 38.2322 22.5644L31.0902 34.9358C30.8156 35.4115 30.4206 35.8064 29.945 36.081C29.4693 36.3556 28.9298 36.5001 28.3806 36.5H14.0965C13.5473 36.5 13.0079 36.3554 12.5323 36.0808C12.0567 35.8063 11.6615 35.4114 11.3868 34.9358Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_112721_616)",
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .07,
				d: "M37.5771 26.1313L28.2122 16.7664L21.2388 13.6538L14.5729 17.2752L14.2935 25.2579L25.8696 36.8321L30.3997 36.7913L37.5771 26.1313Z",
				fill: "black"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0488 16.6449L21.6071 12.9256C21.4954 12.8612 21.3688 12.8273 21.2399 12.8273C21.111 12.8273 20.9844 12.8612 20.8727 12.9256L14.431 16.6449C14.3194 16.7094 14.2267 16.802 14.1623 16.9137C14.0979 17.0253 14.0639 17.1519 14.064 17.2808V24.7191C14.064 24.9814 14.2038 25.2238 14.431 25.3549L20.8727 29.0742C20.9844 29.1387 21.111 29.1726 21.2399 29.1726C21.3688 29.1726 21.4954 29.1387 21.6071 29.0742L28.0488 25.3549C28.1604 25.2905 28.2531 25.1978 28.3175 25.0862C28.3819 24.9746 28.4158 24.848 28.4158 24.7191V17.2808C28.4158 17.0185 28.276 16.7761 28.0488 16.6449ZM27.1651 24.0073L24.9177 22.7098V19.2917L21.5989 21.2071V25.0407L24.5588 23.3318L26.8062 24.6293L21.2398 27.8431L15.6733 24.6293L17.9207 23.3318L20.8809 25.0407V21.2071L17.5621 19.2917V22.7098L15.3147 24.0073V17.5798L20.8812 14.366V16.9611L17.9209 18.67L21.2398 20.5854L24.5586 18.67L21.5986 16.9611V14.366L27.1651 17.5798V24.0073Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_112721_616",
			x1: 3.82553,
			y1: 5.49973,
			x2: 3.82553,
			y2: 36.4513,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4387FD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4683EA"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgGke);
export { ForwardRef as ReactComponent };
